import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from '../../../../../reducers/selectors/metadata';
import { selectListReminder } from '../../../selectors/reminder.selector';
import {
  deleteReminder,
  listReminder,
} from '../../../actions/reminder/reminder.actions';
import moment from 'moment';
import { LIST_REMINDER_SUCCESS } from '../../../actions/reminder/constants';
import { ACTIONS, CATEGORY, EVENTS, pushEvent } from '../../../utils/analytics';
import { GetRegion, PLAYER_SEGMENT } from '../../../../../constants.js';
import { browserHistory } from 'react-router';
import { getPurchaseButtonInfoForEPGTransactions } from 'action-creators/payway/purchaseButtonInfo';
import { showEpgTransactions } from 'containers/Player/actions/epgTransactions/epgTransactions.actions';
import { PlayerContext } from '../../../context/PlayerContext';
import { useNavigate } from 'react-router-dom';

export const useAlertRimender = () => {
  const { liveVideoTagRef } = useContext(PlayerContext);
  const dispatch = useDispatch();
  const [show, setShow] = useState(null);
  const title = useRef(null);
  const channel = useRef(null);
  const schedule = useRef(null);
  const logo = useRef(null);
  const groupId = useRef(null);
  const reminderId = useRef(null);
  const channelData = useRef(null);

  const translations = useSelector(state => state?.translations);
  const {
    reminder_alert_description_futureEvent_label,
    reminder_alert_option_button_tuneinPlay,
    reminder_alert_option_button_close,
  } = translations;
  const timeout = useSelector(
    selectMetadataKeyByRegion('sentinel_reminders_interval'),
  );

  const listData = useSelector(selectListReminder);
  const userHash = useSelector(store => store?.user?.userhash);
  const linealChannel = useSelector(state => state?.linealChannel?.data);
  const pathname = browserHistory.getCurrentLocation()?.pathname;
  const navigate = useNavigate();

  useEffect(() => {
    if (!userHash) return;
    dispatch(
      listReminder({
        user_hash: userHash,
      }),
    );
  }, []);

  const cutText = text =>
    (text.length > 30 && `${text?.substring(0, 27)}...`) || text;

  const checkReminder = () => {
    listData?.map(eventData => {
      const now = moment().format('YYYY-MM-DD hh:mm');
      const alertAt = moment(eventData?.data?.begintime)
        .subtract(10, 'minutes')
        .format('YYYY-MM-DD hh:mm');
      if (now === alertAt) {
        const timeStart = moment(eventData?.data?.begintime).format('HH:mm');
        const timeEnd = moment(eventData?.data?.endtime).format('HH:mm');
        title.current = cutText(eventData?.data?.name);
        channel.current = eventData?.data?.channel_number;
        logo.current = eventData?.data?.channel_image;
        schedule.current = `${timeStart}hs a ${timeEnd}hs`;
        groupId.current = eventData?.data?.channel_group_id;
        reminderId.current = eventData?.id;
        channelData.current = eventData?.data?.channel_group;
        setShow(true);
      }
      return eventData;
    });
  };

  useEffect(
    () => {
      if (listData?.length === 0) return;
      checkReminder();
      const reminderInterval = setInterval(() => {
        checkReminder();
      }, 60000);
      return () => {
        clearTimeout(reminderInterval);
      };
    },
    [JSON.stringify(listData)],
  );

  const filterReminderList = () => {
    const filterlist = listData?.filter(l => l?.id !== reminderId?.current);
    dispatch({ type: LIST_REMINDER_SUCCESS, payload: filterlist });
  };

  const handleShowTransactions = () => {
    dispatch(
      getPurchaseButtonInfoForEPGTransactions({ group_id: groupId?.current }),
    );
    dispatch(showEpgTransactions(channelData.current?.common));
    const isInPlayer = pathname?.includes('watch');
    if (isInPlayer) liveVideoTagRef.current?.pause();
  };

  const handleWatchReminder = () => {
    filterReminderList();
    pushEvent(
      EVENTS.TV,
      CATEGORY.SCHEDULE,
      ACTIONS.REMINDER,
      `sintonizar / {{${title?.current}}}`,
    );
    dispatch(
      deleteReminder({
        user_hash: userHash,
        reminder_id: reminderId.current,
        showAlert: false,
      }),
    );
    setShow(false);
    const canPlayReminderContent =
      linealChannel?.[groupId.current]?.live?.canPlay === 1;
    if (canPlayReminderContent)
      return navigate(`/${GetRegion()}${PLAYER_SEGMENT}${groupId?.current}`);
    handleShowTransactions();
  };

  const handleCloseReminder = () => {
    filterReminderList();
    pushEvent(
      EVENTS.TV,
      CATEGORY.SCHEDULE,
      ACTIONS.REMINDER,
      `cerrar / {{${title?.current}}}`,
    );
    dispatch(
      deleteReminder({
        user_hash: userHash,
        reminder_id: reminderId?.current,
        showAlert: false,
      }),
    );
    setShow(false);
  };

  return {
    reminder_alert_description_futureEvent_label,
    reminder_alert_option_button_tuneinPlay,
    reminder_alert_option_button_close,
    handleWatchReminder,
    handleCloseReminder,
    schedule,
    logo,
    title,
    channel,
    show,
    userHash,
  };
};
